import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiSearch } from 'react-icons/fi';

import styles from './AdminHeaderSearch.scss';

export default function AdminHeaderSearch({ ...props }) {
    const { t } = useTranslation('cards');

    return (
        <div className={styles.searchHeader}>
            <div className={styles.searchInputContainer}>
                <input
                    className={styles.searchInput}
                    type="text"
                    name="name"
                    placeholder={t('PageProductsMain.search')}
                    {...props}
                />
                <div className={styles.searchIcon}>
                    <FiSearch size={16} color="#8E8E93" />
                </div>
            </div>
        </div>
    );
}
